import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { Button, Tag } from "capitalrx-components-2.0/lib/general";
import { Body, Semibold, Subheading } from "capitalrx-components-2.0/lib/typography";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

import { StackOrShelf } from "@/App/components/StackOrShelf";
import { SectionPanel } from "@/App/components";

import { ActivityTypeMap } from "@/App/api/recentActivity";
import { CLAIM, DENTAL, PRIOR_AUTHORIZATION, VISION } from "@/App/constants/constants";

interface ActivityCardProps {
  id: string;
  activity: ActivityTypeMap;
}

const CLAIMS_PAGE_TRANSLATION_PATH = "DASHBOARD.recentActivityDashboard";

export const ActivityCard = ({ id, activity }: ActivityCardProps) => {
  const { t: translate } = useTranslation();
  const formattedActivityDate = DateTime.fromISO(activity.sortable_date).toFormat("DDD");

  return (
    <SectionPanel className="activity-card">
      <Stack>
        <Stack spacing="mini">
          <Shelf>
            <ActivityTypeTag activity={activity} />
            <Shelf.Spacer />
            <Body><Semibold>{formattedActivityDate}</Semibold></Body>
          </Shelf>
          <Stack spacing="none" >
            {
              activity.type === PRIOR_AUTHORIZATION && (
                <Body><Semibold>ID: </Semibold>{id}</Body>
              )
            }
            <Subheading>{activity.title}</Subheading>
          </Stack>
        </Stack>
        {activity.description}
        <StackOrShelf>
          {activity.type === PRIOR_AUTHORIZATION && <Button appearance="text" onClick={activity.link}>{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.viewCase`)}</Button>}
          {activity.type !== PRIOR_AUTHORIZATION && <Button appearance="text" onClick={activity.link}>{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.viewClaim`)}</Button>}
          <Shelf.Spacer />
        </StackOrShelf>
      </Stack>
    </SectionPanel>
  );
};


const ActivityTypeTag = ({ activity }: {activity: ActivityCardProps["activity"]}) => {
  const { t: translate } = useTranslation();

  if (activity.type === PRIOR_AUTHORIZATION) {
    return <Tag type="system-alternative">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.priorAuthorization`)}</Tag>;
  } else if (activity.type === CLAIM) {
    return <Tag type="system">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.pharmacyClaim`)}</Tag>;
  } else {
    switch (activity.data.type) {
      case VISION:
        return <Tag type="info">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.visionClaim`)}</Tag>;
      case DENTAL:
        return <Tag type="info">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.dentalClaim`)}</Tag>;
      default:
        return <Tag type="success">{translate(`${CLAIMS_PAGE_TRANSLATION_PATH}.medicalClaim`)}</Tag>;
    }
  }
};
